export const IconConstants = {
  ARCHIVE: "archive",
  UNARCHIVE: "inventory",
  DELETE: "delete",
  EDIT: "edit",
};
